import { HttpMethod, UploadCommand } from "~/extensions/api";
export class InsertAdminInformationCommand extends UploadCommand {
    constructor(model) {
        super(HttpMethod.Post, "information/admin/insert");
        this.startAt = model.startAt;
        this.endAt = model.endAt;
        this.target = model.target ?? 0;
        this.nyukyokeiyakuNo = model.nyukyokeiyakuNo;
        this.buknCd = model.buknCd;
        this.departmentCode = model.departmentCode;
        this.weight = model.weight;
        this.isMailNotification = model.isEmailNotification;
        this.emailNotificationDate = model.emailNotificationDate;
        this.emailNotificationHour = model.emailNotificationHour;
        this.emailNotificationMinute = model.emailNotificationMinute;
        this.subject = model.subject;
        this.main = model.main;
        this.importFiles = model.newFiles;
        this.isResponseRequired = model.isResponseRequired;
        this.responseDeadline = model.responseDeadline;
        this.affirmativeText = model.affirmativeText;
        this.negativeText = model.negativeText;
        this.negativeNotificationDepartment = model.negativeNotificationDepartment;
    }
    startAt = "";
    endAt = "";
    target = 0;
    nyukyokeiyakuNo = null;
    buknCd = null;
    departmentCode = null;
    weight = false;
    isMailNotification = false;
    emailNotificationDate = "";
    emailNotificationHour = null;
    emailNotificationMinute = null;
    subject = "";
    main = "";
    importFiles = [];
    isResponseRequired = false;
    responseDeadline = "";
    affirmativeText = "";
    negativeText = "";
    negativeNotificationDepartment = [];
}
